"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledH6 = exports.StyledH5 = exports.StyledH4 = exports.StyledH3 = exports.StyledH2 = exports.StyledH1 = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = _interopRequireDefault(require("../../theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 2.2rem;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 2.8rem;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 2.4rem;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 3.6rem;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 3.2rem;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 4.8rem;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-size: 4rem;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var BaseHeading = (0, _styledComponents.css)(["margin:0;padding:0;font-family:", ";font-size:3.2rem;font-weight:600;font-style:normal;font-stretch:normal;line-height:1.25;letter-spacing:normal;color:", ";", " ", ""], _theme["default"].buenosAires, _theme["default"].textColor, function (props) {
  return props.color === 'light' && (0, _styledComponents.css)(["color:", ";"], _theme["default"].textColorLight);
}, function (props) {
  return props.color === 'white' && (0, _styledComponents.css)(["color:white;"]);
});

var StyledH1 = _styledComponents["default"].h1.withConfig({
  displayName: "styled-components__StyledH1",
  componentId: "sc-1sz9c1e-0"
})(["", ";font-size:3.2rem;line-height:1.25;", " ", ""], BaseHeading, _theme["default"].mediaMediumPlus(_templateObject()), _theme["default"].mediaLargePlus(_templateObject2()));

exports.StyledH1 = StyledH1;

var StyledH2 = _styledComponents["default"].h2.withConfig({
  displayName: "styled-components__StyledH2",
  componentId: "sc-1sz9c1e-1"
})(["", ";font-size:2.6rem;line-height:1.3;", " ", ""], BaseHeading, _theme["default"].mediaMediumPlus(_templateObject3()), _theme["default"].mediaLargePlus(_templateObject4()));

exports.StyledH2 = StyledH2;

var StyledH3 = _styledComponents["default"].h3.withConfig({
  displayName: "styled-components__StyledH3",
  componentId: "sc-1sz9c1e-2"
})(["", ";font-size:2.2rem;line-height:1.3;", " ", ""], BaseHeading, _theme["default"].mediaMediumPlus(_templateObject5()), _theme["default"].mediaLargePlus(_templateObject6()));

exports.StyledH3 = StyledH3;

var StyledH4 = _styledComponents["default"].h4.withConfig({
  displayName: "styled-components__StyledH4",
  componentId: "sc-1sz9c1e-3"
})(["", ";font-size:2rem;line-height:1.3;", ""], BaseHeading, _theme["default"].mediaLargePlus(_templateObject7()));

exports.StyledH4 = StyledH4;

var StyledH5 = _styledComponents["default"].h5.withConfig({
  displayName: "styled-components__StyledH5",
  componentId: "sc-1sz9c1e-4"
})(["", ";font-size:1.8rem;line-height:1.25;"], BaseHeading);

exports.StyledH5 = StyledH5;

var StyledH6 = _styledComponents["default"].h6.withConfig({
  displayName: "styled-components__StyledH6",
  componentId: "sc-1sz9c1e-5"
})(["", ";font-size:1.6rem;line-height:1.25;"], BaseHeading);

exports.StyledH6 = StyledH6;